import { CodeSurfer, CodeSurferColumns } from "code-surfer";
import customTheme from "../../../../../../decks/reactivuety/theme.js";
import "prismjs/components/prism-tsx";
import Logo from "../../../../../../decks/reactivuety/Logo.jsx";
import App1 from "../../../../../../decks/reactivuety/src/App1.jsx";
import App2 from "../../../../../../decks/reactivuety/src/App2.jsx";
import App3 from "../../../../../../decks/reactivuety/src/App3.jsx";
import App4 from "../../../../../../decks/reactivuety/src/App4.jsx";
import * as React from 'react';
export default {
  CodeSurfer: CodeSurfer,
  CodeSurferColumns: CodeSurferColumns,
  customTheme: customTheme,
  Logo: Logo,
  App1: App1,
  App2: App2,
  App3: App3,
  App4: App4,
  React: React
};